import React from 'react';
import AdminHeader from '../../../components/navigation/AdminHeader';

/**
 * Loading state component displayed while fetching companies
 */
const LoadingState = () => {
  return (
    <div className="min-h-screen bg-background">
      <AdminHeader />
      <div className="main-content flex items-center justify-center py-20">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-text-secondary">Loading companies...</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingState;